module.exports = "<svg id=\"fc7d4c19-9dcb-41cf-bac8-faadeb0d8905\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 34.8 49.36\"><title>kite</title><g><path d=\"M12.57,0,0,16H12.57Z\"></path><path d=\"M14.28,0V16H26.83Z\"></path><path d=\"M0,17.72,12.57,34V17.72Z\"></path><path d=\"M14.28,17.72V34L26.84,17.72Z\"></path><path d=\"M13.42,35.12,9,40.81h8.8l-4.4-5.69Z\"></path><path d=\"M28.81,30.55a6,6,0,0,0-6,6v6.84a4.28,4.28,0,0,1-8.55,0v-.86H12.57v.86a6,6,0,0,0,6,6h0a6,6,0,0,0,6-6V36.54a4.28,4.28,0,0,1,8.55,0v1.74a.86.86,0,1,0,1.71,0V36.56a6,6,0,0,0-6-6Z\"></path></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/kite.svg
// module id = 572
// module chunks = 1